"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("react"),
  a = require("styled-components"),
  n = require("prop-types"),
  r = require("./link-8b1ebef7.js"),
  l = require("./taggedTemplateLiteral-97b463ad.js"),
  o = require("polished/lib/helpers/rem"),
  i = require("./grid-965d799c.js"),
  d = require("./typography-fb2881fe.js"),
  u = require("./styles-df7980c2.js");
function g(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var c,
  f,
  p,
  s,
  m,
  b,
  h,
  y,
  k,
  T,
  L,
  I,
  O,
  j,
  U,
  w,
  v = g(t),
  x = g(a),
  P = g(n),
  R = g(o),
  q = a.keyframes(c || (c = l._taggedTemplateLiteral(["\n  0% {\n    filter: blur(", ");\n  }\n  100% {\n    filter: blur(0);\n  }\n"])), R["default"](20)),
  D = x["default"](i.Col)(f || (f = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.themeType,
      r = e.backgroundVariant,
      o = e.branding,
      i = t.largeUp(),
      d = t.large1200Up();
    return a.css(p || (p = l._taggedTemplateLiteral(["\n      background-color: ", ";\n      padding: ", ";\n      height: 100%;\n      min-height: ", ";\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    "])), u.getSectionBackgroundColor(r, o, t, n), i ? R["default"](60) : "".concat(R["default"](32), " ").concat(R["default"](16), " ").concat(R["default"](48)), d ? R["default"](450) : "unset");
  }),
  _ = x["default"](i.Container)(s || (s = l._taggedTemplateLiteral(["\n  z-index: 1;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n"]))),
  C = x["default"].div(m || (m = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      n = e.bgImageLargeUpDefault,
      r = e.bgImageLargeUpLowRes,
      o = e.bgImageLargeUpWebp,
      i = e.bgImageXSmallUpDefault,
      d = e.bgImageXSmallUpLowRes,
      u = e.bgImageXSmallUpWebp,
      g = e.bgImageMediumUpDefault,
      c = e.bgImageMediumUpLowRes,
      f = e.bgImageMediumUpWebp,
      p = t.largeUp(),
      s = t.mediumUp(),
      m = R["default"](210),
      h = i,
      y = d || "",
      k = u || "";
    return p ? (h = n, y = r || "", k = o || "") : s && (h = g || n, y = c || r || "", k = f || o || ""), a.css(b || (b = l._taggedTemplateLiteral(["\n      position: ", ";\n      top: 0;\n      left: 0;\n      width: 100%;\n      min-height: ", ";\n      height: ", ";\n      background: ", " no-repeat scroll 50% 20%;\n      background-position: right 0;\n      background-image: url(", ");\n      background-image: url(", ");\n      background-position-y: 0%;\n      background-size: cover;\n      transform: scale(1);\n      -webkit-animation: ", " 1s both;\n      animation: ", " 1s both;\n      @media print {\n        && {\n          display: none !important;\n        }\n      }\n    "])), s ? "absolute" : "unset", m, s ? "100%" : m, t.colors.background.lightTheme.heroLazyLoad, y, k || h, q, q);
  }),
  S = x["default"](r.LinkComponent)(h || (h = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.applyTopPadding,
      r = t.smallUp();
    return a.css(y || (y = l._taggedTemplateLiteral(["\n      min-width: ", ";\n      ", "\n      ", "\n    "])), r ? R["default"](200) : R["default"](150), n && "margin-top: ".concat(R["default"](8), ";"), !r && "\n        margin-left: auto;\n        margin-right: auto;\n      ");
  }),
  E = x["default"](i.Row)(k || (k = l._taggedTemplateLiteral(["\n  height: 100%;\n  text-align: left;\n  justify-content: left;\n"]))),
  M = x["default"].section(T || (T = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return a.css(L || (L = l._taggedTemplateLiteral(["\n    overflow: hidden; /** for bg blur-up */\n    padding-top: 0; /** for bg blur-up // overwrite global section padding */\n    padding-bottom: 0; /** for bg blur-up // overwrite global section padding */\n    position: relative;\n    align-items: center;\n    background-color: ", ";\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n    padding: 0;\n  "])), t.colors.neutral.white, t.colors.neutral.grayDark20);
  }),
  N = x["default"](d.TypographyComponent)(I || (I = l._taggedTemplateLiteral(["\n  padding-bottom: ", ";\n"])), R["default"](32)),
  W = x["default"](d.TypographyComponent)(O || (O = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = R["default"](26),
      r = R["default"](32),
      o = R["default"](16),
      i = t.mediumUp();
    return t.largeUp() ? (n = R["default"](44), r = R["default"](52)) : i && (n = R["default"](35), r = R["default"](41)), a.css(j || (j = l._taggedTemplateLiteral(["\n      font-family: 'Guardian Sans', 'Helvetica Neue', Helvetica, sans-serif;\n      padding-bottom: ", ";\n      line-height: ", ";\n      font-size: ", ";\n      ::after {\n        display: block;\n        width: ", ";\n        padding-bottom: ", ";\n        border-bottom: ", " solid ", ";\n        content: '';\n      }\n    "])), o, r, n, R["default"](60), o, R["default"](4), t.colors.gold.gold);
  }),
  X = x["default"](d.TypographyComponent)(U || (U = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumUp(),
      n = R["default"](12),
      r = R["default"](18),
      o = R["default"](16);
    return t && (n = R["default"](16), r = R["default"](22)), a.css(w || (w = l._taggedTemplateLiteral(["\n      && {\n        padding-bottom: ", ";\n        font-size: ", ";\n        line-height: ", ";\n        font-weight: 400;\n        letter-spacing: ", ";\n        text-transform: uppercase;\n      }\n    "])), o, n, r, R["default"](2.5));
  });
function z(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function A(t) {
  for (var a = 1; a < arguments.length; a++) {
    var n = null != arguments[a] ? arguments[a] : {};
    a % 2 ? z(Object(n), !0).forEach(function (a) {
      e._defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
var V = function V(e) {
  var n = e.backgroundImageAriaLabel,
    r = e.backgroundImageDesktop,
    l = e.backgroundImageDesktopLowRes,
    o = e.backgroundImageDesktopWebp,
    i = e.backgroundImageMobile,
    d = e.backgroundImageMobileLowRes,
    u = e.backgroundImageMobileWebp,
    g = e.backgroundImageTablet,
    c = e.backgroundImageTabletLowRes,
    f = e.backgroundImageTabletWebp,
    p = e.backgroundVariant,
    s = e.branding,
    m = e.className,
    b = e.ctaPrimary,
    h = e.ctaSecondary,
    y = e.descriptionText,
    k = e.headingText,
    T = e.productName,
    L = e.sectionId,
    I = e.themeType,
    O = t.useContext(a.ThemeContext).largeUp(),
    j = v["default"].createElement(C, {
      id: "background-image-".concat(L),
      className: "hero-section-bg-image-container",
      bgImageLargeUpDefault: r,
      bgImageLargeUpLowRes: l,
      bgImageLargeUpWebp: o,
      bgImageXSmallUpDefault: i,
      bgImageXSmallUpLowRes: d,
      bgImageXSmallUpWebp: u,
      bgImageMediumUpDefault: g,
      bgImageMediumUpLowRes: c,
      bgImageMediumUpWebp: f
    }, v["default"].createElement("span", {
      role: "img",
      "aria-label": n
    }));
  return v["default"].createElement(M, {
    id: "section-".concat(L),
    className: m,
    role: "banner",
    "data-module": "section-".concat(L, ":hero-module:A")
  }, !O && j, v["default"].createElement(_, null, v["default"].createElement(E, null, v["default"].createElement(D, {
    medium: 6,
    backgroundVariant: p,
    branding: s,
    themeType: I
  }, v["default"].createElement(v["default"].Fragment, null, v["default"].createElement(X, {
    id: "hero-product-name-".concat(L),
    className: "hero-product-name",
    component: "h1",
    themeType: I,
    variant: "p"
  }, T), v["default"].createElement(W, {
    id: "hero-heading-text-".concat(L),
    className: "hero-heading-text",
    align: "left",
    component: "h2",
    themeType: I,
    variant: "h1"
  }, k), v["default"].createElement(N, {
    id: "hero-description-text-".concat(L),
    className: "hero-description-text",
    align: "left",
    themeType: I
  }, y), b && v["default"].createElement(S, {
    id: "".concat(L, "-cta-primary"),
    className: "hero-link-cta-primary",
    ariaLabel: b.ariaLabel,
    isInternalPdf: b.isInternalPdf && !b.isOutgoingLink,
    isOutgoingLink: b.isOutgoingLink && !b.isInternalPdf,
    linkUrl: b.linkUrl,
    themeType: I,
    scrollConfig: b.scrollConfig,
    variant: "buttonLinkPrimary"
  }, b.buttonText, " "), h && v["default"].createElement(S, {
    id: "".concat(L, "-cta-secondary"),
    className: "hero-link-cta-secondary",
    applyTopPadding: !0,
    ariaLabel: h.ariaLabel,
    isInternalPdf: h.isInternalPdf && !h.isOutgoingLink,
    isOutgoingLink: h.isOutgoingLink && !h.isInternalPdf,
    linkUrl: h.linkUrl,
    themeType: I,
    scrollConfig: h.scrollConfig,
    variant: "buttonLinkSecondary"
  }, h.buttonText, " "))))), O && j);
};
V.propTypes = {
  backgroundImageAriaLabel: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  backgroundImageDesktop: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  backgroundImageDesktopWebp: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundImageDesktopLowRes: P["default"].any.isRequired,
  backgroundImageTabletLowRes: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundImageTablet: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundImageTabletWebp: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundImageMobileLowRes: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundImageMobile: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  backgroundImageMobileWebp: P["default"].oneOfType([P["default"].string, P["default"].object]),
  backgroundVariant: P["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: P["default"].oneOf(["nm", "pcg"]),
  className: P["default"].string,
  ctaPrimary: P["default"].shape(A({
    buttonText: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired
  }, r.linkPropTypes)),
  ctaSecondary: P["default"].shape(A({
    buttonText: P["default"].oneOfType([P["default"].string, P["default"].object])
  }, r.linkPropTypes)),
  descriptionText: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  headingText: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  productName: P["default"].oneOfType([P["default"].string, P["default"].object]).isRequired,
  sectionId: P["default"].string.isRequired,
  themeType: P["default"].oneOf(["lightTheme", "darkTheme", "nmx-pcg"])
}, V.defaultProps = {
  ctaSecondary: null
}, exports.HeroSectionComponent = V;